import { AdlSectionExtended, CarePlan } from '@lmc/ts-common'

export const getSectionsToSave = (
  assessment: CarePlan,
  formSections: Record<string, string>
) => {
  return assessment.carePlanAdl?.sections?.map(
    (section: AdlSectionExtended) => ({
      ...section,
      value: formSections?.[section?.key || 0],
    })
  )
}

export const getDefaultPBSSections = (assessment: CarePlan) => {
  return assessment?.carePlanAdl?.sections?.map(
    (section: AdlSectionExtended) => ({
      ...section,
      value: '',
    })
  )
}

export const getFormSectionsInitialValue = (assessment: CarePlan) => {
  const entries = new Map(
    assessment?.sections?.map((section) => [section.key, section.value])
  )

  const sections = Object.fromEntries(entries)

  return sections
}
